import { Navigate, useLocation } from "react-router-dom";
import { ALL_INFO_STEPS, APP_URLS } from "../const/AppConst";
import useAppState from "../context/AppContext";
import { hasValidateJwt } from "../utils/utils";
import { hasLockMode } from "../utils/dataUtils";


export type ProtectedRouteProps = {
    outlet: JSX.Element;
}

export default function ProtectedRoute({outlet}: ProtectedRouteProps) {
  
  const {
    state: { proposition, isAuthenticated, jwtToken },
  } = useAppState();

  const currentLocation = useLocation();
 
  
  if(proposition && isAuthenticated) {

    if(!hasValidateJwt(jwtToken!)) {
      sessionStorage.clear();
      return <Navigate to={APP_URLS.validatePage}/>;
    }

    const category = ALL_INFO_STEPS.find(step => step.path === currentLocation.pathname)?.category || '';

    if ( currentLocation.pathname !== "/contrat-collectif/souscription/recapitulatif" && hasLockMode(proposition.stateCode, category)) {
      return <Navigate to={APP_URLS.recapPage}/>;
    }

    return outlet;
  } else {
    return <Navigate to={APP_URLS.validatePage}/>;
  }
};